export type MonthRangePreset = '6m' | '1y' | 'all';

const OPTIONS: { value: MonthRangePreset; label: string }[] = [
  { value: '6m', label: '直近6ヶ月' },
  { value: '1y', label: '直近1年' },
  { value: 'all', label: '全期間' },
];

/** 直近月から起算した year_month_from/to を計算する ('all' は呼び出し側で年月範囲を別途決める) */
export const rangeForPreset = (preset: MonthRangePreset, monthsBack = 24): { from: string; to: string } => {
  const now = new Date();
  const to = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  const count = preset === '6m' ? 6 : preset === '1y' ? 12 : monthsBack;
  const fromDate = new Date(now.getFullYear(), now.getMonth() - (count - 1), 1);
  const from = `${fromDate.getFullYear()}-${String(fromDate.getMonth() + 1).padStart(2, '0')}`;
  return { from, to };
};

export const MonthRangeSelector = ({ value, onChange }: { value: MonthRangePreset; onChange: (v: MonthRangePreset) => void }) => (
  <div role="group" aria-label="表示期間" className="inline-flex rounded-md border border-surface-border overflow-hidden">
    {OPTIONS.map((opt) => (
      <button
        key={opt.value}
        type="button"
        aria-pressed={value === opt.value}
        onClick={() => onChange(opt.value)}
        className={`px-3 py-2 text-[13px] font-bold min-h-[40px] focus-ring transition-colors ${
          value === opt.value
            ? 'bg-brand-red text-white'
            : 'bg-white text-text-body hover:bg-surface-sunken'
        }`}
      >
        {opt.label}
      </button>
    ))}
  </div>
);
